/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Row_Reason_No_FileInputs */

const en_zotero_browser_row_reason_no_file = /** @type {(inputs: Zotero_Browser_Row_Reason_No_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No file synced to Zotero`)
};

const es_zotero_browser_row_reason_no_file = /** @type {(inputs: Zotero_Browser_Row_Reason_No_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún archivo sincronizado con Zotero`)
};

/**
* | output |
* | --- |
* | "No file synced to Zotero" |
*
* @param {Zotero_Browser_Row_Reason_No_FileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_row_reason_no_file = /** @type {((inputs?: Zotero_Browser_Row_Reason_No_FileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Row_Reason_No_FileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_row_reason_no_file(inputs)
	return en_zotero_browser_row_reason_no_file(inputs)
});